export default "__VITE_ASSET__772b28ec__"